import type { Address, SheetRow } from '../types/entities';

export function formatAddress(address?: Address): string {
  if (!address) return '';
  return [address.address_line_1, address.city, address.state, address.postal_code, address.country].filter(Boolean).join(', ');
}

export async function hashRow(row: SheetRow): Promise<string> {
  const stable = Object.keys(row).sort().reduce<SheetRow>((acc, key) => {
    if (key !== 'synced_at' && key !== 'sync_hash') acc[key] = row[key];
    return acc;
  }, {});
  const input = JSON.stringify(stable);
  const data = new TextEncoder().encode(input);
  const digest = await globalThis.crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest)).map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function withSyncFields(row: SheetRow, syncedAt = new Date().toISOString()): Promise<SheetRow> {
  const syncHash = await hashRow(row);
  return { ...row, synced_at: syncedAt, sync_hash: syncHash };
}
